import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { organizationSlice } from "../features/organization/organizationSlice";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { persistReducer, persistStore } from "redux-persist";
import { combineReducers } from "redux";
import { approvalEditSlice } from "../features/approval-edit/approvalEditSlice";
import { approvalCreateSlice } from "../features/approvalsCreate/approvalCreateSlice";
import { authSlice } from "../features/auth/authSlice";
import { layoutSlice } from "src/features/layout/layoutSlice";
import * as Sentry from "@sentry/react";
import { dashboardSlice } from "src/features/dashboard/dashboardSlice";

const persistConfig = {
  key: "redux-persist-v2",
  storage,
};

const rootReducer = combineReducers({
  approvalCreate: approvalCreateSlice.reducer,
  approvalEdit: approvalEditSlice.reducer,
  organization: organizationSlice.reducer,
  auth: authSlice.reducer,
  layout: layoutSlice.reducer,
  dashboard: dashboardSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);
persistor.purge();

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

Sentry.setContext("redux", {
  "persist-key": persistConfig.key,
});
